import { render, staticRenderFns } from "./EntryList.vue?vue&type=template&id=f80408a4&scoped=true&"
import script from "./EntryList.vue?vue&type=script&lang=js&"
export * from "./EntryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80408a4",
  null
  
)

export default component.exports